import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import HeaderServicios from './vistas/HeaderServicios';
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import { useisUserAdmin, useNombreEmpresaReal } from '../../../config/unificacion';
import { useUsers } from '../../../metodos/userContext';
import EditableField from '../../../components/EditableFields';
import FileUploader from '../../../components/FileUploader';
import FileViewer from '../../../components/FileViewer';
import { formatearFechaCompleta } from '../../../utils/utils';

const DetallesEntregaTrabajo = () => {
    const { nombreEmpresa, codigo, idEntrega} = useParams();
    const [servicioListo, setServicioListo] = useState(false);
    let nombreEmpresaReal =  useNombreEmpresaReal(nombreEmpresa);
    const {usuario} = useUsers();
    const isAdmin = useisUserAdmin(usuario);
    const [formData, setFormData] = useState({
      trabajos: [],
      comentarioEntrega : "",
    });
    const [confirmado, setConfirmado] = useState(false);
    const {
        servicio,
        loadingServicios,
        errorServicios,
        updateServicio,
        cargarServicioPorCodigo,
        entregaParcialTrabajoTutor,
        setupWebSocketsServicios,
    } = useContabilidadModel();

    //entrega especifica seleccionada
    const entregaEspecifica = useMemo(() => {
      console.log("id de entrega",idEntrega);
      if (!idEntrega || !Array.isArray(servicio?.entregasTrabajo)) {
        return null;
      }
      return servicio.entregasTrabajo.find(e => e.id === idEntrega);
    }, [servicio?.entregasTrabajo, idEntrega]);

    useEffect(() => {
            // Si el servicio ya se cargó o está cargando, no hacer nada
            if (servicioListo ) {
            return;
            }
    
            
            const cargarServicio = async () => {
                try {
                    console.log("Cargando servicio con código:", codigo ,nombreEmpresa);
                    const servicioObjeto = await cargarServicioPorCodigo(nombreEmpresa,codigo);
    
                    if(servicioObjeto){
                      setupWebSocketsServicios(servicioObjeto, nombreEmpresaReal);
                    }
    
                    setServicioListo(true);
                } catch (error) {
                    console.error("Error al cargar el servicio:", error);
                    setServicioListo(false);
                }
            };
    
            console.log("el codigo es",codigo);
            
            if (codigo) {
                cargarServicio();
            }
    
            // Cleanup function
            /*
            return () => {
                if (socketCleanup) {
                    socketCleanup();
                }
            };
            */
    
    }, [codigo, cargarServicioPorCodigo, loadingServicios]);

    if(loadingServicios){
        return (
        <div className="flex justify-center items-center h-screen">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
        </div>
        );
    }

    if (!servicio) {
        return (
        <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">Aviso: </strong>
            <span className="block sm:inline">No se encontró el servicio con el código especificado.</span>
        </div>
        );
    }

    const handleSave = async(field, value) =>{
      const finalupdate = {
        "value" : value,
        "elementId": idEntrega,
      }
      await updateServicio(codigo,nombreEmpresaReal,field,finalupdate,'array');
    }

    const handleFormularioEntrega = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value
      });
    };

    const handleCheckboxChange = (e) => {
      setConfirmado(e.target.checked);
    };

    const entregarTrabajo = async() =>{
      await entregaParcialTrabajoTutor(formData,codigo,nombreEmpresa,idEntrega);
    }

  return (
    // Contenedor principal con un fondo sutil
    <div className="bg-gray-50/50 p-4 sm:p-6 lg:p-8">
      <HeaderServicios servicio={servicio} entregaId={idEntrega} />

      {/* --- TARJETA 1: DETALLES DE LA ENTREGA (2 COLUMNAS) --- */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8">
        <h3 className="text-xl font-bold text-gray-800 mb-6 border-b pb-4">
          Detalles de la Entrega {servicio.materia}
        </h3>
        
        {/* Grid que se activa en pantallas medianas (md) en adelante */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
          
          <EditableField
            field="entregasTrabajo.motivoEntrega"
            label="Tipo de Entrega"
            value={entregaEspecifica?.motivoEntrega}
            type="text"
            isAdmin={isAdmin}
            onSave={handleSave}
          />

          <EditableField
            field="entregasTrabajo.motivo"
            label="Motivo"
            value={entregaEspecifica?.motivo}
            type="text"
            isAdmin={isAdmin}
            onSave={handleSave}
          />

          <EditableField
            field="entregasTrabajo.fechaentrega"
            label="Fecha de entrega"
            value={entregaEspecifica?.fechaentrega}
            type="datetime"
            isAdmin={isAdmin}
            onSave={handleSave}
          />

          <EditableField
            field="entregasTrabajo.fechaSistema"
            label="Fecha de sistema"
            value={entregaEspecifica?.fechaSistema}
            type="datetime"
            isAdmin={false}
            onSave={handleSave}
          />
          {/* El campo de descripción puede ocupar las dos columnas */}
          <div className="md:col-span-2">
            <EditableField
              field="entregasTrabajo.descripcion"
              label="Descripción"
              value={entregaEspecifica?.descripcion}
              type="textarea" // Usar textarea para descripciones largas
              isAdmin={isAdmin}
              onSave={handleSave}
            />
          </div>
          

        </div>
      </div>

      {/* --- TARJETA 2: ARCHIVOS ADJUNTOS --- */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8">
        <h3 className="text-xl font-bold text-gray-800 mb-6 border-b pb-4">
          Archivos Adjuntos
        </h3>

        {/* Subir archivos */}
        {!entregaEspecifica.getTrabajoEntregado() && (
          <div className="mb-6">
            <h4 className="text-md font-semibold text-gray-700 mb-3 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg>
              Subir nuevos archivos
            </h4>
            <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:bg-gray-100 transition-colors">
              <FileUploader
                formData={formData}
                setFormData={setFormData}
                fieldName="trabajos"
                allowedTypes={[]}
                maxSize={100 * 1024 * 1024}
                label="trabajo"
                multiple={true}
              />
            </div>
          </div>
        )}

        {/* Vista de archivos */}
        <FileViewer
          IdCarpeta={servicio.codigo}
          isEntregaParcial={true}
          idEntrega={idEntrega}
          nombreEmpresa={servicio.nombreEmpresa}
          onDeleteFile={(files) => {
          }}
        />
      </div>

      {/* --- TARJETA 3: FINALIZAR ENTREGA --- */}
      <div className="bg-white p-6 rounded-xl shadow-md">
        {!entregaEspecifica.getTrabajoEntregado() ? (
          <>
            <h3 className="text-xl font-bold text-gray-800 mb-6 border-b pb-4">
              Finalizar Entrega
            </h3>

            {/* Comentarios */}
            <div className="mb-8">
              <label htmlFor="comentarioEntrega" className="block text-md font-semibold text-gray-700 mb-3">Comentarios de entrega</label>
              <textarea
                id="comentarioEntrega"
                className="w-full p-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-shadow"
                rows="4"
                name="comentarioEntrega"
                value={formData.comentarioEntrega}
                onChange={handleFormularioEntrega}
                placeholder="Añade cualquier comentario o nota adicional para el cliente..."
              ></textarea>
            </div>

            {/* Confirmación */}
            <div className="bg-amber-50 p-5 rounded-xl border border-amber-200 mb-8 shadow-sm">
              {/* ... Contenido de la confirmación (no necesita cambios) ... */}
               <div className="flex items-start mb-4">
                        <input 
                          type="checkbox" 
                          checked={confirmado}
                          onChange={handleCheckboxChange}
                          id="confirm" 
                          className="mt-1 mr-3 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500" 
                        />
                        <label htmlFor="confirm" className="text-gray-700 font-medium">
                          Confirmo que este trabajo es 100% original y cumple con <span className="uppercase font-bold text-blue-800">TODOS</span> los requisitos y criterios SOLICITADOS en la descripción de la actividad.
                        </label>
                      </div>
                      
                      <div className="bg-white border-l-4 border-red-500 p-4 rounded-r-md mb-4">
                        <p className="font-semibold text-red-700 mb-2 flex items-center gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                          </svg>
                          IMPORTANTE:
                        </p>
                        <ul className="text-sm text-gray-700 ml-5 list-disc space-y-2">
                          <li><span className="font-semibold">Revise detenidamente</span> la información y descripción de la solicitud antes de entregar.</li>
                          <li>Es <span className="font-semibold">OBLIGATORIO</span> adjuntar el reporte de plagio e IA junto con la entrega final (solo si lo requiere, los trabajos que requieren esto son cualquier trabajo que no se haga a mano).</li>
                          <li>No se permiten trabajos con más del <span className="font-semibold">15% de similitud</span> en el reporte de plagio.</li>
                          <li>No se permiten trabajos con más del <span className="font-semibold">20% de contenido generado por IA</span>.</li>
                        </ul>
                      </div>
                      
                      <p className="text-sm text-gray-600 italic">
                        El incumplimiento de estos criterios resultará en el rechazo del trabajo y posibles penalizaciones.
                        Todos los trabajos serán verificados mediante Turnitin.
                      </p>
            </div>

            {/* Botones */}
            <div className="flex justify-end">
              <button
                onClick={entregarTrabajo}
                disabled={!confirmado}
                className={`px-6 py-3 rounded-lg transition-colors flex items-center justify-center gap-2 font-medium shadow-md ${
                  confirmado
                    ? 'bg-green-600 text-white hover:bg-green-700 cursor-pointer'
                    : 'bg-gray-400 text-gray-600 cursor-not-allowed'
                }`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                Finalizar y entregar
              </button>
            </div>
          </>
        ) : (
          // Mensaje de éxito si ya fue entregado
          <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 shadow-sm">
             <div className="flex items-center justify-center mb-4">
                        <div className="h-16 w-16 bg-green-100 rounded-full flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                      </div>
                      <h3 className="text-xl font-bold text-center text-green-700 mb-2">
                        ¡Trabajo entregado con éxito!
                      </h3>
                      <p className="text-center text-green-600 mb-4">
                        Este trabajo fue entregado el {formatearFechaCompleta(entregaEspecifica.entregatutorFecha)}
                      </p>
          </div>
        )}
      </div>
      

    </div>
  );

}

export default DetallesEntregaTrabajo
